/* eslint-disable no-unused-vars */
// linter gives a false-positive for typescript-enums, needs to investigate
export enum ChatUserRolesEnum {
  OWNER = 'owner',
  CREATOR = 'creator',
  USER = 'user',
  MEMBER = 'member',
}
